import PropTypes from 'prop-types';
import React from 'react';

import UserListItem from '../../Users/UserListItem/UserListItem';

export default class FollowedUser extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        followedUser: PropTypes.object.isRequired,
        className: PropTypes.string,
        callbackFn: PropTypes.func,
    };

    static defaultProps = {
        shouldShowCtaButtons: true,
        className: 'network-item',
    };

    render() {
        const { followedUser, className, callbackFn } = this.props;
        return (
            <li className="component-Network-FollowedUser">
                <UserListItem
                    user={followedUser}
                    buttonsToRender={['UNFOLLOW']}
                    followStatus={true}
                    className={className}
                    onClickHandlers={{ onUnfollowCallback: callbackFn }}
                />
            </li>
        );
    }
}
